module.exports = __webpack_public_path__ + "img/fondo-banner-principal.f6ae4c14.svg";